import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";
import { TypeManagerDecorator } from "../../../../../main/type.map.service";
import { S25IconButtonComponent } from "../../../../../standalone/s25.icon.button.component";
import { PopoverComponent } from "../../../../s25-popover/popover.component";

/** A line item that charges nothing, which the reader can take out of the table. */
@TypeManagerDecorator("s25-ng-pricing-hideable-item")
@Component({
    selector: "s25-ng-pricing-hideable-item",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25IconButtonComponent, PopoverComponent],
    host: { class: "pricing-hideable-item" },
    template: `
        <span>{{ itemName() }}</span>

        <s25-popover [popoverTemplate]="popoverText" [isTooltip]="true" [triggerTabIndex]="-1">
            <s25-ng-icon-button [type]="'no'" [ariaLabel]="hideLabel()" (clicked)="hide.emit()" />
        </s25-popover>
    `,
    styles: `
        :host {
            display: flex !important;
            align-items: center;
            gap: 0.25rem;
        }
    `,
})
export class S25PricingHideableItemComponent {
    readonly itemName = input("");

    readonly hide = output<void>();

    protected readonly popoverText = "Items totalling $0 can be hidden";

    protected readonly hideLabel = computed(() => (this.itemName() ? `Hide ${this.itemName()}` : "Hide line item row"));
}
